<div>
  <ng-container *ngTemplateOutlet="templateRef; context:templateContext"></ng-container>
</div>

